import { OnlineSales } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import type { HasInsuranceDebtsDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/common';

export const useUpdateHasInsuranceDebts = (): {
    updateHasInsuranceDebts: (hasInsuranceDebts: HasInsuranceDebtsDTO[]) => Promise<void>;
} => {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const updateHasInsuranceDebts = async (
        hasInsuranceDebts: HasInsuranceDebtsDTO[]
    ): Promise<void> => {
        await OnlineSales.updateHasInsuranceDebts(jobNumber, sessionId, hasInsuranceDebts);
    };

    return { updateHasInsuranceDebts };
};
